export default __webpack_public_path__ + "static/media/Milestone 5L.007e86f5.svg";